<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Logs</h2>
      <LogsPagination
        :perPage="20"
        :queryStructure="queryStructure"
        @items-updated="itemsUpdated"
        ref="paginationComponent"
      />
      <b-row>
        <b-table :fields="fields" :items="groupsArray" :busy="groupsArray === null"
          selectable @row-clicked="showLog" :select-mode="'single'"
          :striped="true" :small="true" :hover="true" :responsive="true">
          <template slot="log_name" slot-scope="data">
            {{data.item.log_name}}
          </template>

          <template slot="description" slot-scope="data">
            {{data.item.description}}
          </template>

          <template #cell(created_at)="data">
            {{parseDate(data.item.created_at)}}
          </template>

        </b-table>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';
import datetime from '@/mixins/datetime';
import LogsPagination from '@/components/pagination/LogsPagination.vue';

export default {
  components: { LogsPagination },
  mixins: [formsMixin, datetime],
  data() {
    return {
      groupsArray: null,
      queryStructure: {
        pagePropName: 'page',
        perPagePropName: 'per_page',
        searchPropName: 'search',
        responseDataKey: 'log',
      },
      fields: [
        { key: 'log_name', label: 'Log name' },
        { key: 'description', label: 'Description' },
        { key: 'created_at', label: 'Date and Time' },
      ],
      publishStatus: ['Unpublished', 'Published'],
    };
  },
  methods: {
    itemsUpdated(data) {
      this.groupsArray = data;
    },
    statusChanged() {
      this.$refs.paginationComponent.pageChanged(1);
    },
    showLog(target) {
      let finalTarget = null;

      if (typeof target === 'number') {
        finalTarget = target;
      } else if (target && target.id) {
        finalTarget = target.id;
      }
      this.$router.push({ name: 'showLog', params: { id: finalTarget } });
    },
    createGroup() {
      this.$router.push({ name: 'showLog', params: { id: 'new' } });
    },
  },
};
</script>
